import { render, staticRenderFns } from "./TextRunRule.vue?vue&type=template&id=37f926c2"
import script from "./TextRunRule.vue?vue&type=script&lang=js"
export * from "./TextRunRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports